import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { useApi } from "@/plugins/api/api";
import GeneralUserInfoTable from "./GeneralUserInfoTable.vue";
import GeneralUserDepartmentTable from "./GeneralUserDepartmentTable.vue";
import GeneralUserPasswordDialog from "./GeneralUserPasswordDialog.vue";

export type SelfUserInfo = {
  code: string;
  name: string;
  kanaName: string;
  sex: string;
  birthDay: string;
  authority: string;
  affiliationCode: string;
  affiliationName: string;
  entryDate: string;
  retirementDate: string;
  enrollmentClass: string;
  salaryClass: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'GeneralUserView',
  setup(__props) {

const { Paths, $get } = useApi();

const item = ref<SelfUserInfo>();

const onSearch = async () => {
  const result = await $get<SelfUserInfo>(Paths.userMaster.general);
  if (result) item.value = result;
};
const onSubmit = async () => {
  await onSearch();
};

onMounted(async () => {
  await onSearch();
});

return { __sfc: true,Paths, $get, item, onSearch, onSubmit, GeneralUserInfoTable, GeneralUserDepartmentTable, GeneralUserPasswordDialog }
}

})